import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

const routeRecord: RouteRecordRaw = {
  name: 'client.messanger',
  path: 'messanger',
  component: () => import('src/client/pages/ClientMessanger.vue'),
  meta: {
    roles: [Roles.Client],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
}

export default routeRecord
